import { createSlice } from '@reduxjs/toolkit';
import { threadsApi } from '../api/threadsApi';

const initialState = {
  title: '',
  category: '',
  body: '',
};

const draftSlice = createSlice({
  name: 'draft',
  initialState,
  reducers: {
    setDraftTitle: (state, action) => {
      state.title = action.payload;
    },
    setDraftCategory: (state, action) => {
      state.category = action.payload;
    },
    setDraftBody: (state, action) => {
      state.body = action.payload;
    },
    clearDraft: (state) => {
      state.title = initialState.title;
      state.category = initialState.category;
      state.body = initialState.body;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      threadsApi.endpoints.createThread.matchFulfilled,
      (state) => {
        state.title = initialState.title;
        state.category = initialState.category;
        state.body = initialState.body;
      }
    );
  },
});

export const { setDraftTitle, setDraftCategory, setDraftBody, clearDraft } =
  draftSlice.actions;

export default draftSlice.reducer;
